class Haptic
{
    private isAllowed : boolean = false;
    private isEnabled : boolean = true;
 
    constructor()
    {
        if ( typeof window == 'undefined') return;
        
        this.init();
    }

    private init()
    {
        let obj : any = navigator;
        if( !obj ) return;

        this.isAllowed = obj.vibrate || obj.webkitVibrate || obj.mozVibrate || obj.msVibrate;
    }

    public setEnabled( bool:boolean )
    {
        this.isEnabled = bool;
    }

    public vibrate( value:any )
    {
        if( !this.isAllowed || !this.isEnabled ) return;
        navigator.vibrate( value );
    }
 
    public long()
    {
        this.vibrate( 1000 );
    }
 
    public medium()
    {
        this.vibrate( 250 );
    }

    public short()
    {
        this.vibrate( 50 );
    }

    public mini()
    {
        this.vibrate( 25 );
    }
 
    public stop()
    {
        this.vibrate( 0 );
    }
 
    // EFFECTS: Fade In

    public fadeIn( duration?:number ) 
    {
        duration = duration || 1000;

        var pulses : any = [],
            d,
            i;

        if (duration < 100) 
        {
            pulses = duration;
        } else {
            d = duration / 100;
            for (i = 1; i <= 10; i += 1) {
                pulses.push(i * d);
                if (i < 10) {
                    pulses.push((10 - i) * d);
                }
            }
        }
        this.vibrate(pulses);
    }

    // EFFECTS: Fade Out

    public fadeOut( duration?:number ) 
    {
        duration = duration || 1000;

        var pulses : any = [],
            d,
            i;

        if (duration < 100) 
        {
            pulses = duration;
        } else {
            d = duration / 100;
            for (i = 1; i <= 10; i += 1) {
                pulses.push(i * d);
                if (i < 10) {
                    pulses.push((10 - i) * d);
                }
            }
            pulses.reverse();
        }
        this.vibrate(pulses);
    };

    // EFFECTS: notification

    public notification( duration?:number ) 
    {
        var pause, dot, dash;

        duration    = duration || 1000;
        pause       = duration / 27;
        dot         = 2 * pause;
        dash        = 3 * pause;

        this.vibrate( [dot, pause, dot, pause, dot, pause * 2, dash, pause, dash, pause * 2, dot, pause, dot, pause, dot] );
    };

    // EFFECTS: heartbeat

    public heartBeat( duration?:number ) 
    {
        var pause, dot, dash;

        duration    = duration || 500;
        dot         = duration / 60;
        pause       = dot * 2;
        dash        = dot * 24;

        this.vibrate( [dot, pause, dash, pause * 2, dash, pause * 2, dot] );
    };

    // EFFECTS: clunk

    public clunk( duration?:number ) 
    {
        var pause, dot, dash;

        duration    = duration || 500;
        dot         = duration * 4 / 22;
        pause       = dot * 2;
        dash        = dot / 2 * 5;

        this.vibrate( [dot, pause, dash] );
    };
}

export default Haptic;